import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import { ReactComponent as SearchSvg } from "../components/icon/search.svg";

interface SearchInputProps {
  filterValue: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  selectedFilters: string[];
}

const SearchInput: React.FC<SearchInputProps> = ({
  filterValue,
  onSearchChange,
  selectedFilters,
}) => {
  return (
    <TextField
      sx={{
        flex: "flex",
        borderRadius: 2,
        border: "1px rgba(95, 143, 222, 0.50) solid",
        height: "fit",
        width: "91.5%",
        padding: 0,
        paddingBottom: 0,
        alignSelf: "center",
        marginRight: "1%",
        marginLeft: "0%",
        marginTop: "1%",
        marginBottom: "1%",
        borderColor: "#5F8FDE80",
        fontStyle: "italic",
      }}
      size="small"
      variant="outlined"
      value={filterValue}
      onChange={onSearchChange}
      placeholder={
        selectedFilters.length
          ? `Filtering by: ${selectedFilters.join(", ")}`
          : "Search..."
      }
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchSvg />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchInput;
